// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__o5CBG","title":"FrontImage_title__1fie7"};